<template>
  <main class="print-stage">
    <img src="/assets/images/loading.gif" class="loading" v-if="loading" />
    <div class="print-button" v-if="!loading">
      <button class="button-primary" v-on:click.prevent="printPage()">
        Seite ausdrucken
      </button>
    </div>

    <div class="content" v-if="!loading">
      <img src="/assets/images/rewe-dein-markt-logo.png" class="logo" alt="REWE Dein Markt, Logo" />

      <h1 v-html="headline"></h1>

      <div class="meta">
        <div class="infos">
          <strong>Verkaufszeitraum</strong>
          <span>vom 29.-31.12.{{ currentYear }}</span>
        </div>

        <div class="market" v-if="shoppinglistMarket">
          <strong>Ausgewählter REWE Markt</strong>
          <span
            >{{ shoppinglistMarket.address.street }}<br />
            {{ shoppinglistMarket.address.zip }}
            {{ shoppinglistMarket.address.city }}</span
          >
        </div>
      </div>

      <h2>Merkliste</h2>

      <table class="liste">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th class="price price-one"><small>Einzelpreis</small></th>
            <th class="price"><small>Gesamtpreis</small></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in fullItems" :key="product.nr">
            <td class="pic">
              <div><img :src="product.thumb" alt="" /></div>
            </td>
            <td class="title">
              <div class="title-with-package-hint--dark">
              <small>{{ product.categories[0] }}</small
              ><strong
                ><span v-if="product.count > 1">{{ product.count }}x </span
                >{{ product.title }}<sup>3</sup></strong
              >
            </div>
            </td>
            <td class="not-available">
              <div v-if="!product.available">
                <i class="icon-info circle" aria-hidden="true"></i
                ><span>Im ausgewählten REWE Markt nicht verfügbar.</span>
              </div>
            </td>
            <td class="price-one" width="100">
              <div v-if="product.priceApp > 0">
                <small>Aktionspreis</small>
                {{ product.price | floatWithTwoDecimals }}&nbsp;€
                <br />
                <small>Mit der REWE App</small>
                {{ product.priceApp | floatWithTwoDecimals }}&nbsp;€
              </div>
              <div v-else>
                {{ product.price | floatWithTwoDecimals }}&nbsp;€
              </div>
              
            </td>
            <td class="price-sum">
              <div v-if="product.priceApp > 0">
                <small>Aktionspreis</small>
                {{ parseFloat(product.price * product.count) | floatWithTwoDecimals }}&nbsp;€
                <br />
                <small>Mit der REWE App</small>
                {{ parseFloat(product.priceApp * product.count) | floatWithTwoDecimals }}&nbsp;€
              </div>
              <div v-else>
                {{ parseFloat(product.price * product.count) | floatWithTwoDecimals }}&nbsp;€
              </div>
              
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="pricelabel" colspan="3">
              <h2>Gesamtsumme</h2>
            </td>
            <td class="price" colspan="2">
              <div class="item">
                <small>Preis</small>
                <PriceLabel 
                  :price="sum" 
                  :inline="true" 
                  :big="false" 
                  :printpage="true"
                />
                <div class="bonus" v-if="listContainsBonusProduct">
                  <img src="/assets/images/bonus-badge-25euro.png" alt="25,00 € Bonus" />
                </div>
              </div>
          
            </td>
          </tr>
          
          <tr>
            <td colspan="3" class="priceinfos">
              Alle Preisangaben inkl. MwSt.
            </td>
            
          </tr>
          
        </tfoot>
      </table>

      <div class="footer">
        <div class="legal">
          <p v-html="$l('footerLegal')" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import PriceLabel from "@/components/PriceLabel.vue";
export default {
  name: "printlist",
  components: {
    PriceLabel
  },
  data() {
    return {
      loading: true,
      key: false,
      shoppinglistItems: [],
      shoppinglistMarket: false,
      shoppinglistMarketProducts: []
    };
  },
  mounted: async function() {
    this.key = this.$route.params.key;
    const response = await this.$store.dispatch(
      "getShoppinglistPublic",
      this.key || false
    );
    this.shoppinglistItems = response.items;
    this.shoppinglistMarket = response.market;
    if (this.shoppinglistMarket && this.shoppinglistMarket.nr) {
      this.shoppinglistMarketProducts = await this.$store.dispatch(
        "getMarketProducts",
        this.shoppinglistMarket.nr
      );
    }
    this.loading = false;
  },
  methods: {
    printPage() {
      window.print();
    }
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        window.setTimeout(() => {
          this.printPage();
        }, 1000);
      }
    }
  },
  computed: {
    ...mapState(["allProducts"]),
    currentYear() {
      return moment().format("Y");
    },
    headline() {
      return this.$l("printHeadline");
    },
    sum() {
      let sum = 0;
      this.fullItems.forEach(el => {
        sum += el.price * el.count;
      });
      // return Math.round(sum * 100) / 100;
      return sum;
    },
    listContainsBonusProduct() {
      return this.fullItems.some(el => el.bonusProdukt);
    },
    listEmpty() {
      return this.items.length === 0;
    },
    fullItems() {
      const items = [];
      this.shoppinglistItems.forEach(item => {
        const product = this.allProducts.find(p => p.nr === item.nr);
        if (this.shoppinglistMarket) {
          product.available = this.shoppinglistMarketProducts.find(
            el => el.nr === item.nr
          )
            ? true
            : false;
        } else {
          product.available = true;
        }

        product.count = item.count;
        product.added = item.added;
        items.push(product);
      });
      items.sort((a, b) =>
        a.added > b.added ? -1 : a.added < b.added ? 1 : 0
      );
      return items;
    }
  }
};
</script>

<style lang="scss">
@import "./Print";
</style>
